import VueI18n from 'vue-i18n'
import Vue from 'vue'
import messages from '../messages'

/**
 * Summary.
 * Use this method to create a new VueI18n instance
 *
 * @return {Object} Returns a new VueI18n instance
 */
Vue.use(VueI18n)

export default new VueI18n({
    locale: 'pt_BR',
    messages,
})
